import { createSlice } from "@reduxjs/toolkit"
import {
  getAllTemplates,
  deleteTemplate,
  updateTemplate,
  addTemplate,
  getTemplateById,
} from "store/actions/templatesAction"

const initialState = {
  loading: false,
  isLoading: false,
  templates: [],
  template: null,
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: null,
}

const templatesSlice = createSlice({
  name: "Templates",
  initialState,
  reducers: {
    resetTemplate: state => {
      state.template = null
    },
  },
  extraReducers: builder => {
    builder
      // Get all templates
      .addCase(getAllTemplates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllTemplates.fulfilled, (state, action) => {
        state.loading = false
        state.templates = action.payload.data
        state.totalCount = action.payload.totalCount
        state.totalPages = action.payload.totalPages
        state.currentPage = action.payload.currentPage
        state.itemsPerPage = action.payload.itemsPerPage
      })
      .addCase(getAllTemplates.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Delete template
      .addCase(deleteTemplate.pending, state => {
        state.isLoading = true
        state.error = null
      })
      .addCase(deleteTemplate.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })

      // Update template
      .addCase(updateTemplate.pending, state => {
        state.isLoading = true
        state.error = null
      })
      .addCase(updateTemplate.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })

      // Add template
      .addCase(addTemplate.pending, state => {
        state.isLoading = true
        state.error = null
      })
      .addCase(addTemplate.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(addTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })

      // Get template by id
      .addCase(getTemplateById.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getTemplateById.fulfilled, (state, action) => {
        state.loading = false
        state.template = action.payload.templates?.[0] || null
      })
      .addCase(getTemplateById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetTemplate } = templatesSlice.actions
export default templatesSlice.reducer 